// extracted by mini-css-extract-plugin
export default {"table":"RaffleTable_table__ivKbc","numeric":"RaffleTable_numeric__XfGGo","index":"RaffleTable_index__X8i0L","user":"RaffleTable_user__aVPQw","avatar":"RaffleTable_avatar__SeYfE"};